import { gql } from '@apollo/client';

export const QUERY_PROFILES_FILTER_DRAWER_COUNTS = gql`
  query profilesFilterDrawerCounts($input: ProfileSearchInput!, $resultType: SearchResultType) {
    profilesFilterDrawerCounts: searchProfiles(input: $input, resultType: $resultType) {
      facets {
        __typename
        name
        buckets {
          __typename
          key
          docCount
        }
      }
    }
  }
`;

export const QUERY_TALENTSCOUT_FILTER_DRAWER_COUNTS = gql`
  query talentScoutFilterCounts($input: ProfileSearchInput!, $resultType: SearchResultType) {
    talentScoutFilterCounts: talentScoutSearch(input: $input, resultType: $resultType) {
      facets {
        __typename
        name
        buckets {
          __typename
          key
          docCount
        }
      }
    }
  }
`;

export const QUERY_SUBMISSIONS_FILTER_DRAWER_COUNTS = gql`
  query submissionsFilterDrawerCounts(
    $input: ProfileSearchInput!
    $roleId: Int!
    $submissionStatusCode: String!
    $resultType: SearchResultType
  ) {
    submissionsFilterDrawerCounts: searchSubmissions(
      input: { roleIds: [$roleId], submissionStatusCodes: [$submissionStatusCode], profileSearchInput: $input }
      resultType: $resultType
    ) {
      facets {
        __typename
        name
        buckets {
          __typename
          key
          docCount
        }
      }
    }
  }
`;
